import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-add-pi',
  templateUrl: './add-pi.component.html',
  styleUrls: ['./add-pi.component.scss']
})
export class AddPiComponent implements OnInit {

  close:boolean = false;

  @Output() closeLinkPI = new EventEmitter<boolean>()


  
  constructor() { }

  ngOnInit(): void {
  }

  closePI(message:boolean){
    this.closeLinkPI.emit(message)
  }
}
